module.exports = __webpack_public_path__ + "img/trophy.a8e5d5b.svg";